export default __webpack_public_path__ + "static/media/wellness-logo-variant-one.7103330e.png";